import { Component } from '@angular/core';
import { Faq, FaqCategory } from '../../models/faq.model';

@Component({
  selector: 'app-faq',
  standalone: false,
  templateUrl: './faq.component.html',
  styleUrl: './faq.component.scss',
})
export class FaqComponent {
  categories = [
    {
      title: 'GENERAL_QUESTIONS',
      faqs: [
        {
          question: 'Q1',
          answer: 'A1',
        },
        {
          question: 'Q2',
          answer: 'A2',
        },
        {
          question: 'Q3',
          answer: 'A3',
        },
        {
          question: 'Q4',
          answer: 'A4',
        },
        {
          question: 'Q5',
          answer: 'A5',
        },
      ] as Faq[],
    },
    {
      title: 'PLANS_SUBSCRIPTION',
      faqs: [
        {
          question: 'Q6',
          answer: 'A6',
        },
        {
          question: 'Q7',
          answer: 'A7',
        },
        {
          question: 'Q8',
          answer: 'A8',
        },
      ] as Faq[],
    },
    {
      title: 'FLEX_PLAN',
      faqs: [
        {
          question: 'Q13',
          answer: 'A13',
        },
        {
          question: 'Q14',
          answer: 'A14',
        },
        {
          question: 'Q15',
          answer: 'A15',
        },
        {
          question: 'Q16',
          answer: 'A16',
        },
      ] as Faq[],
    },
    {
      title: 'PRO_PLAN',
      faqs: [
        {
          question: 'Q17',
          answer: 'A17',
        },
        {
          question: 'Q18',
          answer: 'A18',
        },
        {
          question: 'Q19',
          answer: 'A19',
        },
      ] as Faq[],
    },
    {
      title: 'UNLIMITED_PLAN',
      faqs: [
        {
          question: 'Q171',
          answer: 'A171',
        },
        {
          question: 'Q181',
          answer: 'A181',
        },
        {
          question: 'Q191',
          answer: 'A191',
        },
        {
          question: 'Q201',
          answer: 'A201',
        },
      ] as Faq[],
    },
    {
      title: 'ADS_LISTINGS',
      faqs: [
        {
          question: 'Q21',
          answer: 'A21',
        },
        {
          question: 'Q22',
          answer: 'A22',
        },
        {
          question: 'Q23',
          answer: 'A23',
        },
        {
          question: 'Q25',
          answer: 'A25',
        },
      ] as Faq[],
    },
  ] as FaqCategory[];
}
